const Types = {
  UPDATE_SEARCH: 'UPDATE_SEARCH',
  RESET_SEARCH: 'RESET_SEARCH',
};

export default Types;
